var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stories"},_vm._l((_vm.stories),function(story,i){return _c('story',{key:story.id,attrs:{"story":story,"color":_vm.getColor(i)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }